<template>
  <InputIcon>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </InputIcon>
</template>

<script setup lang="ts">
import type { InputIconEmits, InputIconProps } from "primevue";

import { InputIcon } from "primevue";

defineProps</* @vue-ignore */ InputIconProps>();
defineEmits</* @vue-ignore */ InputIconEmits>();
</script>
